import { AHMEDABAD_AREA_GROUPS, AHMEDABAD_AREAS } from '../constants/registration';

/** Area <option>s grouped by AMC zone; keeps a stored value that is no longer listed selectable. */
export default function AreaOptions({ current }) {
  return (
    <>
      {current && !AHMEDABAD_AREAS.includes(current) ? <option value={current}>{current}</option> : null}
      {AHMEDABAD_AREA_GROUPS.map((g) => (
        <optgroup key={g.zone} label={g.zone}>
          {g.areas.map((a) => (
            <option key={a} value={a}>
              {a}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
